import React from "react";
import { withRouter } from "react-router-dom";

import {
  createTheme,
  ThemeProvider,
  makeStyles,
} from "@material-ui/core/styles";
import { AppBar, Tabs, Tab, Grid } from "@material-ui/core";

const theme = createTheme({
  palette: {
    primary: {
      main: "#aa1945",
    },
  },
});

const useStyles = makeStyles((theme) => ({
  tab: {
    padding: "0px",
    "& *": {
      fontSize: "20px",
      "@media (max-width: 500px)": {
        fontSize: "12px",
      },
    },
  },
}));

const Nav = () => {
  const classes = useStyles();

  return (
    <Grid container>
      <ThemeProvider theme={theme}>
        <AppBar position="static" color="primary">
          <Tabs aria-label="simple tabs example">
            <Grid container>
              <Grid item xs>
                <Tab label="Home" href="/time_net" className={classes.tab} />
              </Grid>
              <Grid item xs>
                <Tab
                  label="Organisers"
                  href="/time_net/organisers"
                  className={classes.tab}
                />
              </Grid>
              <Grid item xs>
                <Tab
                  label="Attend"
                  href="/time_net/attend"
                  className={classes.tab}
                />
              </Grid>
              <Grid item xs>
                <Tab
                  label="Schedule"
                  href="/time_net/schedule"
                  className={classes.tab}
                />
              </Grid>
            </Grid>
          </Tabs>
        </AppBar>
      </ThemeProvider>
    </Grid>
  );
};

export default withRouter(Nav);
